module.exports = __webpack_public_path__ + "img/weixin-tip.4a89b322.jpg";